/**
 * Function iterates through all the properties of an object and replaces all the null values with empty strings
 * @param input can be object of any type with nested object structure. Type can be specified by generics
 */
export const replaceNullWithEmptyString = <T>(input: T): T => {
  const keys = Object.keys(input);
  keys.forEach((property: any) => {
    if (property instanceof Object) {
      input[property] = replaceNullWithEmptyString(property);
    } else if (input[property] === null) {
      input[property] = '';
    }
  });
  return input;
};
